import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { pathOfHash } from "./places";

/** Pages outside the workspace, whose hash is their own. */
const NOT_WORKSPACE = /^\/(share|login|signup|auth|oauth|extension)(\/|$)/;

/* An old `#/view/agent/…` link goes to its path, in place of the entry it arrived as: a bookmark,
   a notice from the backend (its `link` is `/?org=<org>#/…`), or an in-app `href="#/…"`, which
   resolves against whatever workspace page it sits on. A shared chat or sign-in keeps its hash. */
export default function OldHashLinks() {
  const { pathname, hash, search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const path = NOT_WORKSPACE.test(pathname) ? null : pathOfHash(hash);
    if (path) navigate(path + search, { replace: true });
  }, [pathname, hash, search, navigate]);
  return null;
}
